import React from 'react';
import { Link } from "react-router-dom";
import Ax from '../components/hoc/Ax';
import {connect} from 'react-redux';
import * as actions from '../store/actions/index';
import ApplicationHeader from '../pages/includes/ApplicationHeader';
import ApplicationSidebar from '../pages/includes/ApplicationSidebar';
import './ApplicationLayout.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class ApplicationLayout extends React.Component {
    
  constructor() {
    super();
        this.state      =   {
            isMinimizeSidebar   :   false,
            opensubmenu_id      :   null,
    };
  }

    componentDidMount() {

    }
    
    render                          =   ()  =>  {


        //1. user permission list 
        //2. current route
        //3. permission list for current route
        //4. hasAccess current route
        //5. if hasAccess then render page else redirect to Not visibale page
        //6. hasAccess ? this.props.children : Not visibale page


        return <Ax>
            <ToastContainer icon={true} />
            <div id="wrapper">
                <ApplicationHeader />
                <ApplicationSidebar />
                <div className="main-container">{this.props.children}</div>
            </div>
        </Ax>
    }
}

export default ApplicationLayout;
